module.exports = __webpack_public_path__ + "static/img/jiangli.f9e4c92f.png";